import { render } from "./Dot.vue?vue&type=template&id=60881ff0&scoped=true"
import script from "./Dot.vue?vue&type=script&lang=js"
export * from "./Dot.vue?vue&type=script&lang=js"

import "./Dot.vue?vue&type=style&index=0&id=60881ff0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60881ff0"]])

export default __exports__